/**
 * 解析接口 JSON 文本，避免雪花 id 等大整数被 JSON.parse 四舍五入。
 * 例如 departmentId: 1698962806748721153 在 Preview/JS 中会变成 1698962806748721200。
 *
 * 做法：解析前把指定字段的数字改成字符串，与 Response 原始文本一致。
 */
const DEFAULT_LONG_ID_FIELDS = [
  'id',
  'departmentId',
  'deptId',
  'parentId',
  'signDepartment',
]

export function stringifyLongIdFields(jsonText, fields = DEFAULT_LONG_ID_FIELDS) {
  if (typeof jsonText !== 'string') return jsonText
  let text = jsonText
  fields.forEach((key) => {
    // 仅匹配 15 位及以上数字，避免误改 status、小 id 等
    const reg = new RegExp(`"${key}":(\\d{15,})`, 'g')
    text = text.replace(reg, `"${key}":"$1"`)
  })
  return text
}

export function parseJsonPreserveLongIds(jsonText, fields = DEFAULT_LONG_ID_FIELDS) {
  const safeText = stringifyLongIdFields(jsonText, fields)
  return JSON.parse(safeText)
}
